import React from "react";
import {
  useDeleteCategoryMutation,
  useGetCategoriesQuery,
  useUpdateCategoryMutation,
} from "state/api";
import { getColumns } from "./columns";

import DataGridEditableRow from "components/DataGridEditableRow";

export const Categories = () => {
  return (
    <DataGridEditableRow
      useGet={useGetCategoriesQuery}
      useUpdate={useUpdateCategoryMutation}
      useDelete={useDeleteCategoryMutation}
      getRowHeight={() => "auto"}
      columns={getColumns()}
      baseUrl="/categories"
    />
  );
};

export default React.memo(Categories);
